/**
 * Created by lu on 2017/12/5.
 */
/**
 * alert-success
 * alert-info
 * alert-warning
 * alert-danger
 * **/

var nb = require('../nb');
var Model = nb.define({
    parent: nb.Model,
    method: {
        setOpts: function (inOpts) {
            var self = this;
            var opts = inOpts || {};
            var duration = opts.duration || 2;
            if (this._timeout1) {
                clearTimeout(this._timeout1);
            }
            if (this._timeout2) {
                clearTimeout(this._timeout2);
            }
            this.set('visible', 'fadeInDown');
            this.set('text', opts.text);
            this.set('status', opts.status);
            this._timeout1 = setTimeout(function () {
                self.set('visible', 'fadeOutUp');
                self._timeout2 = setTimeout(function () {
                    self.set('visible', '');
                }, 1000);
            }, duration * 1000);
        }
    }
});
var model = new Model();
var View = require('../view/Alerts');
var view = new View();
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    setTimeout(function () {
        view.$().appendTo(document.body);
    });
}, this);
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/Alerts.js
// module id = 15
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32